import styled from "styled-components";

import { StyledCheckInputBaseProps } from "../CheckInputBase.types";

const CHECK_INPUT_SIZE = "24px";
const TRANSITION_DURATION = 300;
const TRANSITION_TIMING_FUNCTION = "ease-in-out";
const ANIMATION_DURATION = 2 * TRANSITION_DURATION;

export const StyledCheckInputBase = styled.label<StyledCheckInputBaseProps>`
	@keyframes pulseIn {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(0.5);
		}
		100% {
			transform: scale(1);
		}
	}

	@keyframes pulseOut {
		0% {
			transform: scale(1);
		}
		25%,
		75% {
			transform: scale(0.5);
		}
		100% {
			transform: scale(1);
		}
	}

	position: relative;
	display: inline-flex;
	align-items: start;
	cursor: pointer;
	box-sizing: border-box;

	input {
		position: absolute;
		left: 0;
		top: 0;
		width: ${CHECK_INPUT_SIZE};
		height: ${CHECK_INPUT_SIZE};
		margin: 0;
		z-index: 1;
		visibility: hidden;
		box-sizing: border-box;
		opacity: 0;
		transition: background-color ${TRANSITION_DURATION}ms
				${TRANSITION_TIMING_FUNCTION},
			border-color ${TRANSITION_DURATION}ms ${TRANSITION_TIMING_FUNCTION};

		:checked + span {
			${({ theme }) => {
				const COLOR_CTA_DEFAULT = theme.palette.hexForRole("cta_default");
				return {
					backgroundColor: COLOR_CTA_DEFAULT,
					borderColor: COLOR_CTA_DEFAULT,
					"::after": {
						animation: `pulseIn ${ANIMATION_DURATION}ms forwards`,
					},
				};
			}}
		}

		:not(:checked) + span {
			::after {
				animation: pulseOut ${ANIMATION_DURATION}ms forwards;
			}
		}

		+ span {
			display: flex;
			position: relative;
			align-items: center;
			justify-content: center;
			z-index: 1;
			transition: background-color ${TRANSITION_DURATION}ms
					${TRANSITION_TIMING_FUNCTION},
				border-color ${TRANSITION_DURATION}ms ${TRANSITION_TIMING_FUNCTION};

			&::after {
				content: "";
				display: block;
				opacity: 0;
				position: absolute;
				width: ${CHECK_INPUT_SIZE};
				height: ${CHECK_INPUT_SIZE};
				border-radius: 50%;
				pointer-events: none;
				z-index: 0;
				transition: opacity ${TRANSITION_DURATION}ms
						${TRANSITION_TIMING_FUNCTION},
					outline-width ${TRANSITION_DURATION}ms ${TRANSITION_TIMING_FUNCTION};
			}

			${({ theme }) => {
				const COLOR_FG_LIGHT_2 = theme.palette.hexFor("fg_light_2");
				const COLOR_CTA_DEFAULT = theme.palette.hexForRole("cta_default");

				return {
					width: CHECK_INPUT_SIZE,
					height: CHECK_INPUT_SIZE,
					backgroundColor: COLOR_FG_LIGHT_2,
					border: `1px solid ${COLOR_FG_LIGHT_2}`,
					"::after": {
						outline: `0px solid ${COLOR_CTA_DEFAULT}`,
					},

					":hover": {
						borderColor: COLOR_CTA_DEFAULT,
						"::after": {
							outlineWidth: `9px`,
							opacity: 0.1,
						},
					},
				};
			}}
		}

		~ .Typography {
			margin-left: ${({ theme }) => theme.space.sm};
		}
	}
`;
